import { InterpolatedTranslatePipe } from '@web/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FooterActionsComponent } from '../actions/footer-actions.component';

@Component({
  selector: 'cas-footer-need-help',
  template: `
    <div class="d-flex flex-column">
      <section class="d-md-none d-xxl-block text-shadow">
        <h4 class="text-ink-white">{{ 'cas.needHelp' | translate }}</h4>
        <p>{{ 'cas.needHelpSubtitle' | translate }}</p>
      </section>
      <cas-footer-actions class="mt-0 mt-md-4 mt-xxl-0"></cas-footer-actions>
    </div>
  `,
  imports: [FooterActionsComponent, InterpolatedTranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterNeedHelpComponent {}
